import { ApplicationConfig } from '@angular/core';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { routes } from './app.routes';
import { importProvidersFrom } from '@angular/core';
import { TegelModule } from './shared/tegel.module';
import { provideClientHydration } from '@angular/platform-browser';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { toastInterceptor } from './core/interceptors/toast.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes, 
      withPreloading(PreloadAllModules)
    ),
    provideHttpClient(
      withInterceptors([toastInterceptor])
    ),
    provideClientHydration(),
    importProvidersFrom(TegelModule),
  ],
};
